export default {
  metadata: {
    version: '2.0.0',
    id: 'avatar-default-2.0.0',
    name: 'JDSAvatarV2Default'
  },
  hierarchy: {
    container: ['jds_image', 'jds-text', 'icon']
  },
  base: {
    container: {
      hidden: false,
      opacity: '{a_9}',
      width: '{a_0}',
      height: '{a_1}',
      'flex-direction': '{a_2}',
      'justify-content': '{a_3}',
      'align-items': '{a_4}',
      'background-color': '{a_5}',
      'border-radius': '{a_6}',
      behavior: {
        active: {
          'background-color': '{a_10}'
        }
      }
    },
    jds_image: {
      hidden: true,
      aspectRatio: 'round'
    },
    icon: {
      hidden: false,
      size: '{a_12}',
      color: '{a_13}',
      value: 'ic_profile',
      behavior: {
        hover: {
          color: '{a_14}'
        },
        active: {
          color: '{a_15}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_137}',
      color: '{text_12}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true,
      behavior: {
        hover: {
          color: '{text_14}'
        }
      }
    }
  },
  variant: {
    size: {
      'xtra-small': {
        container: {
          width: '{a_16}',
          height: '{a_17}'
        },
        icon: {
          size: '{a_26}'
        },
        'jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      small: {
        container: {
          width: '{a_18}',
          height: '{a_19}'
        },
        icon: {
          size: '{a_27}'
        },
        'jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      large: {
        container: {
          width: '{a_20}',
          height: '{a_21}'
        },
        icon: {
          size: '{a_28}'
        },
        'jds-text': {}
      },
      'xtra-large': {
        container: {
          width: '{a_22}',
          height: '{a_23}'
        },
        icon: {
          size: '{a_29}'
        },
        'jds-text': {
          'font-family': '{text_122}',
          'font-size': '{text_121}',
          'line-height': '{text_123}',
          'letter-spacing': '{text_124}',
          'font-weight': '{text_125}'
        }
      },
      'xtra-xtra-large': {
        container: {
          width: '{a_24}',
          height: '{a_25}'
        },
        icon: {
          size: '{a_30}'
        },
        'jds-text': {
          'font-family': '{text_107}',
          'font-size': '{text_106}',
          'line-height': '{text_108}',
          'letter-spacing': '{text_109}',
          'font-weight': '{text_110}'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{a_31}'
        }
      }
    },
    kind: {
      initials: {
        jds_image: {
          hidden: true
        },
        icon: {
          hidden: true
        },
        'jds-text': {
          hidden: false
        }
      },
      image: {
        container: {
          behavior: {
            hover: {
              'background-color': '{a_34}'
            },
            active: {
              'background-color': '{a_36}'
            }
          }
        },
        jds_image: {
          hidden: false,
          behavior: {
            hover: {
              opacity: '{a_33}'
            },
            active: {
              opacity: '{a_35}'
            }
          }
        },
        icon: {
          hidden: true
        },
        'jds-text': {}
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      jds_image: {
        src: {
          type: 'image',
          name: 'image'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'initials',
          function: true
        }
      }
    },
    config: {
      size: {
        values: [
          'medium',
          'xtra-small',
          'small',
          'large',
          'xtra-large',
          'xtra-xtra-large'
        ]
      },
      kind: {
        values: ['icon', 'initials', 'image']
      },
      disabled: {
        values: [false, true]
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Avatar'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
